import gql from "graphql-tag";

export const UPDATE_USER_TASK = gql`
mutation updateUserTaskAssignee($id: ID!, $input: UpdateUserTaskAssigneeInput!) {
  updateUserTaskAssignee(id: $id, input: $input) {
      id
  }
}`;

export const ARCHIVE_USER_TASK = gql`
mutation archiveUserTask($id: ID!) {
  archiveUserTask(id: $id) {
      id
  }
}`;

export const UPDATE_USER_TASK_AS_COMPLETE =gql`
mutation markUserTaskAsComplete($id: ID!) {
  markUserTaskAsComplete(id: $id) {
      id
      status
  }
}`;

export const UPDATE_USER_TASK_AS_WONT_COMPLETE =gql`
mutation markUserTaskAsWontComplete($id: ID!, $wontCompleteReason: String) {
  markUserTaskAsWontComplete(id: $id, wontCompleteReason:$wontCompleteReason) {
      id
      status
  }
}`;

export const UPDATE_CUSTOM_FORM_INSTANCE = gql`
  mutation updateCustomFormInstance($input: UpdateCustomFormInstanceInput!) {
    updateCustomFormInstance(input: $input) {
      id
      organizationId
      fields {
        fieldId
        fieldName
        displayName
        readOnly
        type
        typeOptions
        defaultValue
        currentValue
        options {
          value
        }
        relatesToEntity {
          provider
          entity
          fieldName
          id
        }
        mapsToEntity {
          provider
          entity
          fieldName
          id
        }
      }
    }
  }
`;
